import React from 'react'
import PropTypes from 'prop-types'
import { TextContext } from 'hocs'
import * as Styled from './IndicatorOverlay.styles'
import { Indicator } from '../'

const IndicatorOverlayContent = ({ indicator = {}, variant = 'circle' }) => {
  const textContext = React.useContext(TextContext)
  return (
    <Styled.NursingIndicatorOverlayContainer>
      <h3>{indicator.title}</h3>
      {indicator.type?.criteria !== undefined && (
        <p>
          <b>
            {indicator.type.criteria}
            {` `}
            <span
              dangerouslySetInnerHTML={{
                __html: indicator.type.title,
              }}
            />
          </b>
        </p>
      )}
      {Array.isArray(indicator.indicator) &&
        indicator.indicator.map((overlayType, index) => (
          <div key={ `overlay-type-${ index }` } className='overlay-type'>
            <b>
              {overlayType.criteria}
              {` `}
              {overlayType.title}
            </b>
            <b className='overlay-type-rating'>
              {overlayType.total ? 'JA' : 'NEIN'}
            </b>
          </div>
        ))}
      {indicator.type?.desc && <p>{indicator.type.desc}</p>}
      {indicator.type?.total !== undefined && (
        <>
          <p>
            <b>{textContext['nursingIndicator.overlay.rating.title']}</b>
          </p>
          <div className='overlay-indicator'>
            <p>
              {
                textContext[
                  `nursingIdicator.overlay.indicator.prefix.${ variant }`
                ]
              }
              {
                textContext[
                  `nursingIndicator.indicator.${ variant }.${ indicator.type.total }`
                ]
              }
            </p>
            <div className='overlay-indicator-rating'>
              <Indicator variant={ variant } rating={ indicator.type.total } />
            </div>
          </div>
        </>
      )}
      {variant === 'square' &&
        indicator.type?.subcriteria.total !== undefined && (
          <p>
            {textContext[`nursingIndicator.result.text.${ variant }`].replace(
              '__TOTAL__',
              indicator.type.subcriteria.total
            )}
          </p>
        )}
      {variant === 'square' && indicator.type?.subcriteria && (
        <>
          <div className='overlay-table-head'>
            <b>
              {textContext['nursingIndicator.overlay.table.firstColumn.head']}
            </b>
            <div className='overlay-table-count'>
              <b>
                {
                  textContext[
                    'nursingIndicator.overlay.table.secondColumn.head'
                  ]
                }
              </b>
            </div>
          </div>
          <hr className='overlay-table-head-divider' />
          {indicator.type.subcriteria.result.map(
            ({ criteria, count }, index) => (
              <React.Fragment key={ `rating-with-count-${ index }` }>
                <div className='overlay-table-row'>
                  <span>
                    <b>{criteria.toLowerCase()}.</b>{' '}
                    {
                      textContext[
                        `nursingIndicator.indicator.subcriteria.${ variant }.${ criteria.toLowerCase() }.`
                      ]
                    }
                  </span>
                  <div className='overlay-table-count'>{count}</div>
                </div>
                <hr />
              </React.Fragment>
            )
          )}
        </>
      )}
      {indicator.type && indicator.type.lastResult && (
        <>
          <p>
            <b>{textContext['nursingIndicator.overlay.pastResults.title']}</b>
          </p>
          {indicator.type.lastResult &&
            indicator.type.lastResult.map((indicator) => (
              <React.Fragment key={ indicator.reportDate }>
                <p className='overlay-rating-date'>{indicator.reportDate}</p>
                <div className='overlay-indicator'>
                  <p>
                    {
                      textContext[
                      `nursingIdicator.overlay.indicator.prefix.${ variant }`
                    ]
                    }
                    {
                      textContext[
                      `nursingIndicator.indicator.${ variant }.${ indicator.result }`
                    ]
                    }
                  </p>
                  <div className='overlay-indicator-rating'>
                    <Indicator variant={ variant } rating={ indicator.result } />
                  </div>
                </div>
                {indicator.desc && <p>{result.desc}</p>}
              </React.Fragment>
            ))}
        </>
      )}
    </Styled.NursingIndicatorOverlayContainer>
  )
}

IndicatorOverlayContent.propTypes = {
  title: PropTypes.string,
  indicator: PropTypes.oneOfType([
    PropTypes.shape({
      criteria: PropTypes.string,
      desc: PropTypes.string,
      total: PropTypes.number,
      lastResult: PropTypes.arrayOf(
        PropTypes.shape({
          reportDate: PropTypes.string,
          result: PropTypes.number,
        })
      ),
      subcriteria: PropTypes.shape({
        total: PropTypes.number,
        result: PropTypes.arrayOf(
          PropTypes.shape({
            criteria: PropTypes.string,
            count: PropTypes.number,
          })
        ),
      }),
    }),
    PropTypes.arrayOf(
      PropTypes.shape({
        criteria: PropTypes.string,
        desc: PropTypes.string,
        total: PropTypes.number,
        lastResult: PropTypes.arrayOf(
          PropTypes.shape({
            reportDate: PropTypes.string,
            result: PropTypes.number,
          })
        ),
        subcriteria: PropTypes.shape({
          total: PropTypes.number,
          result: PropTypes.arrayOf(
            PropTypes.shape({
              criteria: PropTypes.string,
              count: PropTypes.number,
            })
          ),
        }),
      })
    ),
  ]),
  variant: PropTypes.oneOf(['circle', 'square']),
}

export default IndicatorOverlayContent
